export async function getDeviceFingerprint() {
  const navigatorInfo = window.navigator;

  // پردازش صوتی کارت صدا (Audio Fingerprint)
  function getAudioFingerprint() {
    try {
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const analyser = audioContext.createAnalyser();
      const gain = audioContext.createGain();
      const scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);

      oscillator.type = "triangle";
      oscillator.connect(analyser);
      analyser.connect(gain);
      gain.connect(scriptProcessor);
      scriptProcessor.connect(audioContext.destination);
      oscillator.start(0);

      let fingerprint = new Float32Array(analyser.frequencyBinCount);
      analyser.getFloatFrequencyData(fingerprint);
      return fingerprint.slice(0, 10).toString(); // اولین 10 مقدار برای یکتایی
    } catch (e) {
      return "audio-unavailable";
    }
  }

  // دریافت اطلاعات WebGL (کارت گرافیک)
  function getWebGLRenderer() {
    try {
      const canvas = document.createElement("canvas");
      const gl =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      if (!gl) return "webgl-unavailable";

      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      return debugInfo
        ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
        : "unknown";
    } catch (e) {
      return "webgl-unavailable";
    }
  }

  // مقداردهی ویژگی‌ها
  const fingerprintData = {
    architecture: navigatorInfo.userAgentData?.architecture || "unknown",
    audio: getAudioFingerprint(),
    deviceMemory: navigatorInfo.deviceMemory || "unknown",
    hardwareConcurrency: navigatorInfo.hardwareConcurrency || "unknown",
    platform: navigatorInfo.platform || "unknown",
    math: Math.tan(1).toString() + Math.sin(1).toString(), // تابع ریاضی برای fingerprint خاص
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "unknown",
    touchSupport: navigatorInfo.maxTouchPoints > 0 ? "enabled" : "disabled",
    webGLRenderer: getWebGLRenderer(),
  };

  // تولید یک هش یکتا از اطلاعات فوق
  const fingerprintString = JSON.stringify(fingerprintData);
  const hash = await sha256(fingerprintString);

  return hash;
}

// تابع هش کردن رشته با SHA-256
async function sha256(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
}
